import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Batch} from "../../services/batch.service";
import {BatchQuickEdit, BatchRpcService, QuickEditType} from "../../services/batch.rpc.service";
import {Claim, Role} from "../../models/account";
import {AuthenticationService} from "../../services";
import {enableReload, preventReload} from "../../utilities";

@Component({
    selector: 'element-tag-values',
    templateUrl: './tag-values.component.html',
    styleUrls: ['./tag-values.component.scss']
})
export class TagValuesComponent implements OnInit, OnChanges {
    current_role: any;

    constructor(private bs: BatchRpcService, _as: AuthenticationService) {
        this.current_role = _as.getClaim(Claim.Role);
    }

    @Output() onClick = new EventEmitter();
    @Input() values: any[] = [];
    @Input() batch: Batch | null = null;
    @Input() type: QuickEditType | null = null;
    _values: string[] = [];

    @Input() isStatus = false;

    @Input() label = "View more";

    delete_toggled = false;
    delete_toggled_for = "";

    is_loading = false;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.values.currentValue) {
            this._values = changes.values.currentValue.map((value: any) => (typeof value == "string") ? value : value?.label);
        }
    }

    reset() {
        this.delete_toggled_for = "";
        this.delete_toggled = false;
    }

    toggle_delete(value: string) {
        this.delete_toggled_for = value;
        this.delete_toggled = !this.delete_toggled;
    }

    async delete() {

        if (this.type == null || this.batch == null) {
            return;
        }
        // tslint:disable-next-line:no-non-null-assertion
        const id = this.batch!.bid!;

        this._values = this._values.filter(v => v != this.delete_toggled_for);
        const quickEditRequest: BatchQuickEdit = {
            editType: this.type,
            batches: [id],
            tags: [],
            order_numbers: [],
            container_numbers: [],
        };

        switch (this.type) {
            case QuickEditType.Tags:
                quickEditRequest.tags = this._values;
                break;
            case QuickEditType.OrderNumbers:
                quickEditRequest.order_numbers = this._values;
                break;
            case QuickEditType.ContainerNumbers:
              quickEditRequest.container_numbers= this._values;
              break;
        }
        this.is_loading = true;
        const listener = preventReload();
        const that = this;

        function request() {
            return that.bs.processQuickEdit(quickEditRequest);
        }

        const item = this.bs.queueService.enqueue(request);

        item.then((res: any) => {
            if (res.revised_bid && res.revised_bid.length > 0) {
                if (that.batch) {
                    that.batch.bid = res.revised_bid[0];
                }
            }
            if (!that.bs.queueService.workingOnPromise) {
                that.is_loading = false;
                enableReload(listener);
            }
        });


    }

    ngOnInit(): void {
    }


    protected readonly Role = Role;
}
